import { Message } from "../../../js/parsegenerated";

export function getFirstUserMessage(messages: Message[]): Message {
  if (!messages || messages.length === 0) return null;
  const userMessages = messages.filter(
    (message) => message.data?.type === "userinput"
  );

  const first = userMessages.sort(
    (a, b) => a.get("createdAt")?.getTime() - b.get("createdAt")?.getTime()
  )[0];
  return first;
}
